import { useCallback, useState } from "react";
import { namesMatch, normalizeName } from "../../shared/normalizeName";

export function useNameField({
  currentName,
  allItems,
  currentId,
  onCommit,
}: {
  currentName: string | undefined;
  allItems: readonly { id: string; name: string }[];
  currentId: string;
  onCommit: (normalizedName: string) => void;
}) {
  const [editValue, setEditValue] = useState<string | null>(null);
  const displayValue = editValue ?? currentName ?? "";

  const normalized = editValue !== null ? normalizeName(editValue) : null;
  const nameTaken =
    normalized !== null &&
    normalized.length > 0 &&
    normalized !== currentName &&
    allItems.some(
      (item) => item.id !== currentId && namesMatch(item.name, normalized)
    );

  const commit = useCallback(() => {
    if (editValue === null || nameTaken) return;
    const n = normalizeName(editValue);
    if (!n || n === currentName) {
      setEditValue(null);
      return;
    }
    onCommit(n);
    setEditValue(null);
  }, [editValue, nameTaken, currentName, onCommit]);

  return { value: displayValue, setValue: setEditValue, nameTaken, commit };
}
